import React from 'react';
import { useParams } from 'react-router';
import { useManagedQuery } from 'utils/managedHooks';

import Spinner from 'admin-components/components/Spinner';
import { bookingQuery } from './queries';
import ReviewQuote from './ReviewQuote';

const Index = () => {
  const { reference } = useParams();
  const { data, loading } = useManagedQuery(bookingQuery, {
    variables: { reference },
    fetchPolicy: 'network-only'
  });

  if (loading) {
    return <Spinner />;
  }

  return <ReviewQuote booking={data.booking} />;
};

export default Index;
